import { PrivilegeEnum as o } from "@hprofits/shared/auth";
import { z as n } from "zod";
import { ocPrivate as i } from "../common/auth/procedure-builders.js";
import "../common/errors/constants.js";
import { notFoundError as a } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as t } from "../swagger/tags.js";
import { SyndicationDomainIdParamSchema as r, SyndicationDomainsQuerySchema as m, SyndicationDomainsResponseSchema as e } from "./schemas.js";
const l = {
  syndicationDomain: {
    findAll: i([o.ReadPublisher]).route({
      method: "GET",
      path: "/syndication-domains",
      summary: "List the caller's syndication domains",
      tags: [t.SYNDICATION_DOMAINS.name]
    }).input(m).output(e).errors({}),
    remove: i([o.WritePublisher]).route({
      method: "DELETE",
      path: "/syndication-domains/{syndicationDomainId}",
      summary: "Delete one of the caller's syndication domains",
      tags: [t.SYNDICATION_DOMAINS.name],
      successStatus: 204
    }).input(r).output(n.void()).errors({
      ...a("Syndication domain not found")
    })
  }
};
export {
  l as syndicationDomainContract
};
//# sourceMappingURL=contract.js.map
